import { useDispatch, useSelector } from "react-redux";
import styled, { css } from "styled-components";

import { Default, ReduxStates } from "Types";
import { Data as DataType } from "Types/Reducers";
import { actions } from "reducers/redux/data";

import AtomH2 from "Components/Atoms/H2";
import AtomPaper from "Components/Atoms/Paper";
import MoleculeFormText from "Components/Molecules/FormText";

export type PropsType = Default;

const Wrap = styled(AtomPaper)``;

const FormControlWrap = styled(MoleculeFormText.Wrap)``;

export default function OrganismForm1(props: PropsType) {
   const data = useSelector((state: any) => state.data);
   const dispatch = useDispatch();

   function dataOnChange(ev: any, target: string) {
      dispatch({
         type: actions.set,
         payload: {
            ...data,
            [target]: ev.target.value,
         },
      });
   }

   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <AtomH2>1. 신청인 정보</AtomH2>
         <FormControlWrap
            css={css`
               margin-top: 30px;
            `}>
            <MoleculeFormText.Label>이름</MoleculeFormText.Label>
            <MoleculeFormText.Text value={data.v_name} onChange={(ev: any) => dataOnChange(ev, "v_name")}></MoleculeFormText.Text>
         </FormControlWrap>
         <FormControlWrap>
            <MoleculeFormText.Label>이메일</MoleculeFormText.Label>
            <MoleculeFormText.Text value={data.email} onChange={(ev: any) => dataOnChange(ev, "email")}></MoleculeFormText.Text>
         </FormControlWrap>
         <FormControlWrap>
            <MoleculeFormText.Label>휴대폰 번호</MoleculeFormText.Label>
            <MoleculeFormText.Text value={data.hp} onChange={(ev: any) => dataOnChange(ev, "hp")}></MoleculeFormText.Text>
         </FormControlWrap>
      </Wrap>
   );
}
